import DirectusSDK from "@directus/sdk-js";
const isDevelopment = process.env.NODE_ENV === 'development'

export const apiDefaults = {
  //url: isDevelopment ? 'http://localhost:7000' : 'http://archives.martinn3.eu',
    url:  'http://archives.martinn3.eu',
  project: "_",
  storage: window.localStorage,
}

export const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

export const parseJSON = (response) => response.json()

export async function apiFetch(url, signal) {
  const accessToken = window.sessionStorage.accessToken
  try {
    return fetch(url, { 
      signal: signal,
      headers: {
        'Authorization': `Bearer ${accessToken ? accessToken : 'Public'}`,
      },
      cache: "force-cache"
    })
  } catch (error) {
    console.error(error)
  }
}
